// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3Mrz6","checkboxCol":"Table_checkboxCol__3C80E","emailCol":"Table_emailCol__3mvN8","actionCol":"Table_actionCol__2LKHu"};